/* eslint-disable react/jsx-pascal-case */
import { Delete, Edit } from '@mui/icons-material'
import { Box, IconButton } from '@mui/material'
import { MaterialReactTable, MRT_ShowHideColumnsButton, MRT_ToggleDensePaddingButton, MRT_ToggleFullScreenButton } from 'material-react-table'
import React from 'react'

const Perencanaan = ({
    loading,
    data = [],
    columns,
    rowCount = 50,
    pagination,
    setPagination,
    columnFilter,
    setColumnFilter,
    columnVisibility,
    setEditData, handleOpenEdit, deleteData, allowEdit
}) => {

    return (
        <MaterialReactTable
            columns={columns}
            data={data}
            muiTableHeadCellProps={{
                sx: {
                    fontSize: '0.875rem !important',
                    color: 'text.main !important'
                }
            }}
            muiTableFooterCellProps={{
                sx: {
                    fontSize: '0.875rem !important',
                    color: 'text.main !important'
                }
            }}
            muiTopToolbarProps={{
                sx: { fontSize: '0.875rem' }
            }}
            initialState={{
                columnVisibility: columnVisibility,
                showGlobalFilter: false
            }}
            enablePagination={true}
            manualPagination={true}
            muiPaginationProps={{
                rowsPerPageOptions: [50, 100, 200]
            }}
            onPaginationChange={setPagination}
            rowCount={rowCount}

            manualFiltering={true} //turn off client-side filtering
            onColumnFiltersChange={setColumnFilter}

            enableSorting={false}
            renderToolbarInternalActions={({ table }) => (
                <>
                    <MRT_ShowHideColumnsButton table={table} color='text' />
                    <MRT_ToggleFullScreenButton table={table} color='text' />
                    <MRT_ToggleDensePaddingButton table={table} color='text' />
                </>
            )}
            state={{
                isLoading: loading,
                showColumnFilters: true,
                pagination: {
                    pageSize: pagination.pageSize,
                    pageIndex: pagination.pageIndex
                },
                columnFilter
            }}
            displayColumnDefOptions={{
                'mrt-row-actions': {
                    header: 'Aksi', //change header text
                    size: 50, //make actions column wider
                    alignment: 'left'
                },

            }}
            muiFilterTextFieldProps={{
                sx: { width: '100%', paddingLeft: '0rem !important' },
                variant: 'outlined',
            }}
            // renderRowActionMenuItems={({ closeMenu, row }) =>
            //     getMenuItem(row.original, closeMenu, setEditData, handleOpenEdit, deleteData, allowEdit)
            // }
            enableRowActions={true}
            renderRowActions={({ row, table }) => (
                <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
                    <IconButton
                        color="secondary"
                        onClick={() => {
                            setEditData(row.original)
                            handleOpenEdit()
                        }}
                    >
                        <Edit fontSize='small' color='primary' />
                    </IconButton>
                    <IconButton
                        color="error"
                        onClick={() => {
                            deleteData(row.original.kode, row.original.uraian)
                        }}
                    >
                        <Delete fontSize='small' color='error' />
                    </IconButton>
                </Box>
            )}
        />
    )
}

export default Perencanaan